import "./App.css";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Transaction from "./pages/Transactions";
import Vouchers from "./pages/Vouchers";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Fragment, useEffect } from "react";
import axios from 'axios'
import store from "./store";
import { Provider } from "react-redux";
import Header from "./components/Header";
import Alert from "./components/Alert";
import PrivateRoute from './components/PrivateRoute'
import setAuthToken from "./utils/setAuthToken";
import {loadUser} from './actions/users'

if(localStorage.token) {
  setAuthToken(localStorage.token)
}

function App() {
  useEffect(() => {
    axios.defaults.baseURL = "https://oicodebootcamp.herokuapp.com/api/v1";
    store.dispatch(loadUser());
  }, [])
  return (
    <Fragment>
      <Router>
        <Provider store={store}>
          <Header />
          <Alert />
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/register" component={Register} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <PrivateRoute exact path="/transactions" component={Transaction} />
            <PrivateRoute exact path="/vouchers" component={Vouchers} />
          </Switch>
        </Provider>
      </Router>
    </Fragment>
  );
}

export default App;
